// Each slot:
//   id      — unique key in the roster
//   label   — what shows in the empty circle on the field
//   group   — "gk" | "def" | "mid" | "att", used for stat weighting in projection.js
//   top/left — % position on the field
//   accepts — FIFA position codes that can fill this slot

export const FORMATIONS = {
  "4-3-3": [
    {
      id: "LW",
      label: "LW",
      group: "att",
      top: 14,
      left: 20,
      accepts: ["LW", "LM", "LF"],
    },
    {
      id: "ST",
      label: "ST",
      group: "att",
      top: 11,
      left: 50,
      accepts: ["ST", "CF"],
    },
    {
      id: "RW",
      label: "RW",
      group: "att",
      top: 14,
      left: 80,
      accepts: ["RW", "RM", "RF"],
    },
    {
      id: "LCM",
      label: "CM",
      group: "mid",
      top: 38,
      left: 28,
      accepts: ["CM", "CAM", "LM"],
    },
    {
      id: "CDM",
      label: "CDM",
      group: "mid",
      top: 46,
      left: 50,
      accepts: ["CDM", "CM"],
    },
    {
      id: "RCM",
      label: "CM",
      group: "mid",
      top: 38,
      left: 72,
      accepts: ["CM", "CAM", "RM"],
    },
    {
      id: "LB",
      label: "LB",
      group: "def",
      top: 68,
      left: 14,
      accepts: ["LB", "LWB"],
    },
    {
      id: "LCB",
      label: "CB",
      group: "def",
      top: 72,
      left: 36,
      accepts: ["CB"],
    },
    {
      id: "RCB",
      label: "CB",
      group: "def",
      top: 72,
      left: 64,
      accepts: ["CB"],
    },
    {
      id: "RB",
      label: "RB",
      group: "def",
      top: 68,
      left: 86,
      accepts: ["RB", "RWB"],
    },
    { id: "GK", label: "GK", group: "gk", top: 91, left: 50, accepts: ["GK"] },
  ],
  "4-4-2": [
    {
      id: "LST",
      label: "ST",
      group: "att",
      top: 12,
      left: 38,
      accepts: ["ST", "CF"],
    },
    {
      id: "RST",
      label: "ST",
      group: "att",
      top: 12,
      left: 62,
      accepts: ["ST", "CF"],
    },
    {
      id: "LM",
      label: "LM",
      group: "mid",
      top: 40,
      left: 14,
      accepts: ["LM", "LW", "CM"],
    },
    {
      id: "LCM",
      label: "CM",
      group: "mid",
      top: 44,
      left: 38,
      accepts: ["CM", "CDM", "CAM"],
    },
    {
      id: "RCM",
      label: "CM",
      group: "mid",
      top: 44,
      left: 62,
      accepts: ["CM", "CDM", "CAM"],
    },
    {
      id: "RM",
      label: "RM",
      group: "mid",
      top: 40,
      left: 86,
      accepts: ["RM", "RW", "CM"],
    },
    {
      id: "LB",
      label: "LB",
      group: "def",
      top: 68,
      left: 14,
      accepts: ["LB", "LWB"],
    },
    {
      id: "LCB",
      label: "CB",
      group: "def",
      top: 72,
      left: 36,
      accepts: ["CB"],
    },
    {
      id: "RCB",
      label: "CB",
      group: "def",
      top: 72,
      left: 64,
      accepts: ["CB"],
    },
    {
      id: "RB",
      label: "RB",
      group: "def",
      top: 68,
      left: 86,
      accepts: ["RB", "RWB"],
    },
    { id: "GK", label: "GK", group: "gk", top: 91, left: 50, accepts: ["GK"] },
  ],
  "4-2-3-1": [
    {
      id: "ST",
      label: "ST",
      group: "att",
      top: 10,
      left: 50,
      accepts: ["ST", "CF"],
    },
    {
      id: "LAM",
      label: "CAM",
      group: "att",
      top: 28,
      left: 22,
      accepts: ["LW", "LM", "CAM"],
    },
    {
      id: "CAM",
      label: "CAM",
      group: "mid",
      top: 30,
      left: 50,
      accepts: ["CAM", "CM"],
    },
    {
      id: "RAM",
      label: "CAM",
      group: "att",
      top: 28,
      left: 78,
      accepts: ["RW", "RM", "CAM"],
    },
    {
      id: "LDM",
      label: "CDM",
      group: "mid",
      top: 50,
      left: 36,
      accepts: ["CDM", "CM"],
    },
    {
      id: "RDM",
      label: "CDM",
      group: "mid",
      top: 50,
      left: 64,
      accepts: ["CDM", "CM"],
    },
    {
      id: "LB",
      label: "LB",
      group: "def",
      top: 68,
      left: 14,
      accepts: ["LB", "LWB"],
    },
    {
      id: "LCB",
      label: "CB",
      group: "def",
      top: 72,
      left: 36,
      accepts: ["CB"],
    },
    {
      id: "RCB",
      label: "CB",
      group: "def",
      top: 72,
      left: 64,
      accepts: ["CB"],
    },
    {
      id: "RB",
      label: "RB",
      group: "def",
      top: 68,
      left: 86,
      accepts: ["RB", "RWB"],
    },
    { id: "GK", label: "GK", group: "gk", top: 91, left: 50, accepts: ["GK"] },
  ],
  "3-5-2": [
    {
      id: "LST",
      label: "ST",
      group: "att",
      top: 12,
      left: 38,
      accepts: ["ST", "CF"],
    },
    {
      id: "RST",
      label: "ST",
      group: "att",
      top: 12,
      left: 62,
      accepts: ["ST", "CF"],
    },
    {
      id: "LWB",
      label: "LWB",
      group: "mid",
      top: 36,
      left: 10,
      accepts: ["LWB", "LB", "LM"],
    },
    {
      id: "LCM",
      label: "CM",
      group: "mid",
      top: 42,
      left: 32,
      accepts: ["CM", "CAM"],
    },
    {
      id: "CDM",
      label: "CDM",
      group: "mid",
      top: 46,
      left: 50,
      accepts: ["CDM", "CM"],
    },
    {
      id: "RCM",
      label: "CM",
      group: "mid",
      top: 42,
      left: 68,
      accepts: ["CM", "CAM"],
    },
    {
      id: "RWB",
      label: "RWB",
      group: "mid",
      top: 36,
      left: 90,
      accepts: ["RWB", "RB", "RM"],
    },
    {
      id: "LCB",
      label: "CB",
      group: "def",
      top: 72,
      left: 28,
      accepts: ["CB"],
    },
    { id: "CB", label: "CB", group: "def", top: 76, left: 50, accepts: ["CB"] },
    {
      id: "RCB",
      label: "CB",
      group: "def",
      top: 72,
      left: 72,
      accepts: ["CB"],
    },
    { id: "GK", label: "GK", group: "gk", top: 91, left: 50, accepts: ["GK"] },
  ],
};

export const FORMATION_NAMES = ["4-3-3", "4-4-2", "4-2-3-1", "3-5-2"];
export const DEFAULT_FORMATION = "4-3-3";

// Kept for any leftover imports; points at the default formation.
export const FORMATION = FORMATIONS[DEFAULT_FORMATION];

export function findCompatibleSlots(player, roster, slots = FORMATION) {
  if (!player) return [];
  const positions = player.positions?.length ? player.positions : [player.pos];
  return slots
    .filter((slot) => !roster[slot.id])
    .filter((slot) => positions.some((p) => slot.accepts.includes(p)))
    .map((slot) => slot.id);
}

/**
 * Where can a player being *dragged* land?
 * Excludes the source slot. For empty targets, just checks position fit.
 * For occupied targets, also checks the swap is mutually compatible
 * (the target's current player must fit the source slot too).
 */
export function findDragCompatibleSlots(player, roster, slots, sourceSlotId) {
  if (!player) return [];
  const playerPositions = player.positions?.length
    ? player.positions
    : [player.pos];
  const sourceSlot = slots.find((s) => s.id === sourceSlotId);

  return slots
    .filter((slot) => slot.id !== sourceSlotId)
    .filter((slot) => playerPositions.some((p) => slot.accepts.includes(p)))
    .filter((slot) => {
      const targetPlayer = roster[slot.id];
      if (!targetPlayer) return true; // empty slot — always fine
      if (!sourceSlot) return false;
      const targetPositions = targetPlayer.positions?.length
        ? targetPlayer.positions
        : [targetPlayer.pos];
      return targetPositions.some((p) => sourceSlot.accepts.includes(p));
    })
    .map((slot) => slot.id);
}
